import { render, staticRenderFns } from "./ElaborateCourseCommentSection.vue?vue&type=template&id=491a62e2&scoped=true&"
import script from "./ElaborateCourseCommentSection.vue?vue&type=script&lang=js&"
export * from "./ElaborateCourseCommentSection.vue?vue&type=script&lang=js&"
import style0 from "./ElaborateCourseCommentSection.vue?vue&type=style&index=0&id=491a62e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a62e2",
  null
  
)

export default component.exports